import axios from 'axios';
import BaseService from './BaseService'

class JobBoardService extends BaseService {
  constructor () {
    super({entity: 'job-board'})
  }

  async getKpi(jobId, range = 'today') {
    try {
      return await axios.get(`job-boards/${jobId}/kpi`, {
        params: {
          date_range: range
        }
      });
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e });
      throw e;
    }
  }


  get ({limit = 100, ...rest} = {}, path = '') {
    return super.get({
      limit,
      ...rest
    }, path)
  }

  getJobBoardsForProduct (productId) {
    return axios.get(`products/${productId}/job-boards?with=job_board`)
  }
}

export default new JobBoardService()
